const type = 'SET_STATUS_ACCOUNT_PROFILES';

const setAccountStatusProfiles = (data) => ({
  type,
  data,
});

export { type };
export default setAccountStatusProfiles;
